import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Link } from 'gatsby-plugin-react-i18next';
import { useNavigationLinks } from '../../../hooks/useNavigationLinks';
import { MenuToggle } from './menu-toggle';
import './navigation.scss';

export const Navigation: React.FC = () => {
  const navLinks = useNavigationLinks();
  const [menuActive, setActive] = useState<boolean>(false);

  const toggle = () => setActive((state) => !state);

  useEffect(() => {
    document.body.classList.toggle('menu-opened', menuActive);
  });

  return (
    <div className={classNames({ 'navigation--active': menuActive })}>
      <MenuToggle toggle={toggle} />
      <nav id="nav" className="main-nav">
        <MenuToggle toggle={toggle} />
        <ul className="main-nav__list">
          {navLinks.map(({ name, url, isActive }) => (
            <li key={name} className="main-nav__list-item">
              <Link
                className={classNames('main-nav__list-link', { active: isActive })}
                to={url}
              >
                {name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};
